import React, { Fragment } from "react";

const TextAreaInput = ({
  input,
  rows,
  width,
  type,
  placeholder,
  onChange,
  meta: { touched, error },
  options,
}) => {
  return (
    <Fragment>
      <div>
        <textarea
          {...input}
          placeholder={placeholder}
          type={type}
          className="form-control"
          rows={rows}
        ></textarea>
        {touched && error && <label className="error-label">{error}</label>}
      </div>
    </Fragment>
  );
};

export default TextAreaInput;
